import emojiRegex from 'emoji-regex';

/**
 * 가독성을 위한 메시지 줄바꿈 처리
 */
export const splitContentLines = (content: string): string[] => {
  const regex = emojiRegex();
  const pattern = new RegExp(`([.!?~]) ((?:${regex.source})+)?`, 'g');

  const processedContent = content
    .replace(pattern, (_, punct, emojis) => {
      return emojis ? `${punct} ${emojis}\n` : `${punct}\n`;
    })
    .replace(/\\{2,}n/g, '\n')
    .replace(/\n+/g, '\n');

  return processedContent
    .split('\n')
    .map(line => line.trim())
    .filter(Boolean);
};
